import { useNavigate } from "react-router-dom";

export default function Button ({text, color, location}) {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(location);
    }

    return (
        <div
            style={{
                background: "#FECC7B",
                width: 'fit-content',
                paddingLeft: "30px",
                paddingRight: '30px',
                paddingTop: '10px',
                paddingBottom: '10px',
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5px",
                color: color,
                transition: "0.2s linear all",
            }}
            className="hover:cursor-pointer font-poppins text-xl font-light"
            onClick={handleClick}
        >
            {text}
        </div>
    );
}